import * as QueueSelectors from '../../selectors/queue';
import { ENQUEUE, DEQUEUE, REMOVE } from './types';

export function enqueue(notification) {
    return {
        type: ENQUEUE,
        payload: notification.id,
    };
}

export function dequeue() {
    return (dispatch, getState) => {
        if (QueueSelectors.isEmpty(getState())) {
            return null;
        }

        const notificationId = QueueSelectors.head(getState());
        dispatch(removeHeadItemFromQueue());

        return notificationId;
    };
}

function removeHeadItemFromQueue() {
    return {
        type: DEQUEUE,
    };
}

export function remove(notificationId) {
    return {
        type: REMOVE,
        payload: notificationId,
    };
}
